(function(angular){

    var app = angular.module(MyGlobal.page.ngAppName);

    app.controller('MainCtrl', function ($scope, $http, helper) {
        // Page loaded well, remove the shit..
        helper.removePagePreloader();
    });

}(angular));
